/**
 * Photography briefs per service — each brief includes the exact search
 * criteria the user's creative team should hand to Adobe Stock / Shutterstock /
 * Getty to source commercially-licensed, high-resolution imagery. Until real
 * commissioned photography is uploaded via the admin Media Kit, service cards
 * render a labeled placeholder that carries these keywords.
 */

export const PHOTO_BRIEFS = {
  "pressure-washing": {
    subject: "Commercial pressure washing on brick storefront",
    keywords: [
      "commercial pressure washer",
      "surface cleaner attachment",
      "brick storefront",
      "professional technician PPE",
      "hot water rig",
    ],
    sources: "Adobe Stock · Shutterstock · Getty",
  },
  "awning-cleaning": {
    subject: "Awning cleaning on boutique storefront",
    keywords: [
      "commercial awning cleaning",
      "soft brush + suds",
      "storefront canopy",
      "professional technician PPE",
      "low-pressure garden pump",
    ],
    sources: "Adobe Stock · Shutterstock · Getty",
  },
  "window-cleaning": {
    subject: "Commercial window cleaning with water-fed pole",
    keywords: [
      "water-fed pole system",
      "DI water purification",
      "commercial storefront glass",
      "IWCA-safety",
      "streak-free reflective glass",
      "branded uniform + squeegee",
    ],
    sources: "Adobe Stock · Shutterstock · Getty · Unsplash+",
  },
  "sidewalk-cleaning": {
    subject: "Sidewalk pressure-wash w/ surface cleaner attachment",
    keywords: [
      "commercial sidewalk pressure wash",
      "surface cleaner attachment",
      "gum + oil stain removal",
      "storefront walkway",
      "wastewater recovery",
    ],
    sources: "Adobe Stock · Shutterstock · Getty",
  },
  "parking-lot-striping": {
    subject: "Freshly striped commercial parking lot",
    keywords: [
      "parking lot line striping machine",
      "ADA-compliant markings",
      "crosswalk + arrows",
      "airless line striper",
      "bright white + yellow paint on black asphalt",
    ],
    sources: "Adobe Stock · Shutterstock · Getty",
  },
  "parking-lot-sweeping": {
    subject: "Ride-on parking-lot sweeper on commercial pavement",
    keywords: [
      "ride-on parking lot sweeper",
      "regenerative-air sweeper truck",
      "commercial parking lot",
      "night operations",
      "clean asphalt debris removal",
    ],
    sources: "Adobe Stock · Shutterstock · Getty",
  },
  "snow-removal": {
    subject: "Commercial snow plow on parking lot",
    keywords: [
      "commercial snow plow truck",
      "commercial parking lot snow removal",
      "salting + de-icing",
      "walk-behind snowblower",
      "night storm response",
    ],
    sources: "Adobe Stock · Shutterstock · Getty",
  },
  "graffiti-removal": {
    subject: "Graffiti removal on urban brick wall",
    keywords: [
      "graffiti removal in progress",
      "chemical remover + pressure washer",
      "urban brick / stucco wall",
      "half-clean, half-tagged reveal",
      "commercial technician PPE",
    ],
    sources: "Adobe Stock · Shutterstock · Getty",
  },
  "dumpster-cleaning": {
    subject: "Commercial dumpster pad cleaning",
    keywords: [
      "restaurant dumpster enclosure",
      "hot-water pressure wash",
      "commercial waste area",
      "grease + degreaser",
      "wastewater recovery mat",
    ],
    sources: "Adobe Stock · Shutterstock · Getty",
  },
  "outdoor-lighting": {
    subject: "Permanent LED outdoor lighting on storefront",
    keywords: [
      "permanent LED trim lighting",
      "commercial building illuminated at night",
      "warm-white roofline lighting",
      "boutique storefront exterior",
      "app-controlled RGB architectural lighting",
    ],
    sources: "Adobe Stock · Shutterstock · Getty",
  },
  "pest-control": {
    subject: "Commercial pest-control technician exterior perimeter treatment",
    keywords: [
      "commercial pest control technician",
      "backpack sprayer",
      "restaurant + retail exterior",
      "integrated pest management",
      "PPE + safety gear",
    ],
    sources: "Adobe Stock · Shutterstock · Getty",
  },
};
